<script>
import { kebabCase, has, get } from 'lodash'

const agreements = [
  {
    id: 'valuables-bought',
    text: `Any valuables brought to Kamandalu Ubud are at the guest’s sole risk.
          Kamandalu Ubud and/or the management accepts no liability and shall
          not be responsible for any loss or damage there to and guest remains
          responsible for the safekeeping of any such items.`,
  },
  {
    id: 'safe-deposit',
    text: `A safe deposit box is available in your villa and at the lobby. Please
          use this deposit box to store your valuable belongings. The management
          is not responsible for any loss of money, jewelry and any other valuable
          belongings.`,
  },
  {
    id: 'costs-and-charges',
    text: `I am personally liable of all costs and charges incurred during my stay.
          In the event that any such costs and charges are not paid in full nor
          confirmed, I agree that my responsibility and liability in that regard
          is not waived nor released in anyway.`,
  },
  {
    id: 'smoking',
    text: `Smoking is only allowed in open air area (outside of the villa,
          outside Petulu Restaurants and Aira Café).`,
  },
  {
    id: 'pet',
    text: `Kamandalu Ubud does not allow pets (in any form of purpose) to be
          brought to the property.`,
  },
  {
    id: 'injuries',
    text: `Kamandalu Ubud is not responsible for any injuries and/or harms that
          occur in any of the swimming pool area outside of their operating hours.`,
  },
  {
    id: 'durian',
    text: `Kamandalu Ubud strictly does not allow Durian to be brought to
          the property.`,
  },
  {
    id: 'kids',
    text: `If I am travelling with kids, Kamandalu Ubud is not responsible for
          any injuries, and/or harms to any of my children.`,
    modal: {
      title: 'Travelling with Children under 12 years old',
      model: 'childDisclaimer',
    },
  },
  {
    id: 'drone',
    text: `I will not use any forms of unmanned aerial systems and radio
          controlled aircraft device or known as drones without any given
          permission from Kamandalu Ubud.`,
    modal: {
      title: 'Operating drone cameras in resort area',
      model: 'droneDisclaimer',
    },
  },
  {
    id: 'outside-food',
    text: `I will not bring any kind of food from outside of Kamandalu Ubud,
          including food delivery as well as other caterings.`,
    modal: {
      title: 'Outside food disclaimer',
      model: 'outsideFoodDisclaimer',
    },
  },
]

const modals = agreements
  .filter((agreement) => agreement.modal)
  .reduce(
    (accumulator, current) => ({
      ...accumulator,
      [current.modal.model]: false,
    }),
    {}
  )

export default {
  props: {
    policy: { type: Object, required: true },
  },
  data() {
    return {
      agreements,
      modals,
      agreed: false,
    }
  },
  computed: {
    rules() {
      return 'required'
    },
  },
  methods: {
    kebab(str) {
      return kebabCase(str)
    },
    getPolicy({ modal }) {
      return get(this.policy, modal.model)
    },
    hasModal(obj) {
      return has(obj, 'modal')
    },
  },
}
</script>

<template>
  <div>
   <div class="px-3 text-sm italic">
      <p class="mb-2">
        Please carefully read our resort disclaimers and policies.
      </p>
      <ul class="py-2 list-disc ml-4">
        <li v-for="agreement in agreements" :key="agreement.id" class="mb-2">
          <div>
            <span class="block" v-text="agreement.text" />
            <a
              v-if="hasModal(agreement)"
              class="text-gold-500 cursor-pointer"
              href="#"
              @click.prevent="modals[agreement.modal.model] = true"
            >
              (Disclaimer of {{ agreement.modal.title }})
            </a>
          </div>
          <BaseModal
            v-if="hasModal(agreement)"
            v-model="modals[agreement.modal.model]"
            :title="agreement.modal.title"
            size="3xl"
          >
            <!-- eslint-disable vue/no-v-html -->
            <p v-html="getPolicy(agreement)"></p>
          </BaseModal>
        </li>
      </ul>
    </div>
    <BaseValidationProvider
        v-slot="{ errors }"
        :rules="{ required: { allowFalse: false } }"
      >
        <BaseCheckbox
          v-model="agreed"
          label="By ticking this box, I confirm that I have read, understood and agree all of the above. *"
          :class="{ 'text-red-500': errors.length }" />
      </BaseValidationProvider>
  </div>
</template>
